import { PlainTimeSelector } from '../plain-time-selector'
import { PlainWeekdaySelector } from '../plain-weekday-selector/plain-weekday-selector'
import { getWeekdayLocalizedNumber } from './get-weekday-number'
import { SelectorGroupDateView } from './selector-group-date-view'

import styles from './selector-group.module.scss'

type Props = {
  hours: string | null
  minutes: string | null
  weekday: string | null
  showWeeks?: boolean
  onChange: (hours: number | null, minutes: number | null, weekday: number) => void
}

export const SelectorGroup = ({ hours, minutes, weekday, showWeeks, onChange }: Props) => {
  const weekdayIndex = weekday ? getWeekdayLocalizedNumber(weekday) : -1
  const currentHours = hours ? parseInt(hours, 10) : null
  const currentMinutes = minutes ? parseInt(minutes, 10) : null

  return (
    <div className={styles.root}>
      <SelectorGroupDateView
        className={styles.selected}
        weekdayIndex={weekdayIndex}
        currentHours={currentHours}
        currentMinutes={currentMinutes}
        showWeeks={showWeeks}
      />
      {showWeeks && (
        <PlainWeekdaySelector
          className={styles.weekdays}
          currentIndex={weekdayIndex}
          onChange={(idx) => onChange(currentHours, currentMinutes, idx)}
        />
      )}
      <PlainTimeSelector
        className={styles.time}
        currentHours={currentHours}
        currentMinutes={currentMinutes}
        onChangeHours={(hours) => onChange(hours, currentMinutes, weekdayIndex)}
        onChangeMinutes={(minutes) => onChange(currentHours, minutes, weekdayIndex)}
      />
    </div>
  )
}
